import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../shared/services/config/config.service';

@Injectable({
  providedIn: 'root',
})
export class EntitiesService {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
  ) {
    this.baseUrl = this.configService.pessoaApi;
  }

  public registerEntitie(formData: any) {
    return this.http.post(`${this.baseUrl}/v1/entity`, { ...formData });
  }

  getEntitie(EntitieId: string) {
    return this.http.get(this.baseUrl + `/v1/companie/${EntitieId}`);
  }

  deleteEntity(companyId: string | null) {
    return this.http.delete(this.baseUrl + `/v1/companie/${companyId}`);
  }

  getHistorico(EntitieId: string, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidade/${EntitieId}/historico?&page=${pageIndex}&sortDirection=desc`,
    );
  }

  editEntitie(companyId: string | null, entitieData: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(this.baseUrl + '/v1/entity', entitieData, {
      headers,
    });
  }

  getEntities(
    pageSize: number = 10,
    pageIndex?: number,
    sortDirection?: string,
    sortProperty?: string,
    tipoEntidade?: string,
    fantasiaAndRazaoSocial?: string,
    statusFilter?: string,
    cpnj?: string,
    cep?: string,
    cpf?: string,
    nomeRepresentante?: string,
    emailEntidade?: string,
  ): Observable<string[]> {
    const params = new HttpParams()
      .set('size', pageSize.toString())
      .set('page', pageIndex?.toString() || '0')
      .set('sortField', sortProperty || '')
      .set('sortDirection', sortDirection || '')
      .set('tipoEntidade', tipoEntidade || '')
      .set('fantasiaAndRazaoSocial', fantasiaAndRazaoSocial || '')
      .set('status', statusFilter || '')
      .set('cnpj', cpnj || '')
      .set('cep', cep || '')
      .set('cpfRepresentante', cpf || '')
      .set('nomeRepresentante', nomeRepresentante || '')
      .set('emailEntidade', emailEntidade || '');

    return this.http.get<any[]>(this.baseUrl + `/v1/companies`, { params });
  }

  getEntitiesTypes() {
    return this.http.get(this.baseUrl + `/v1/type-companie`);
  }

  getHistoricoConsorcio(id: string, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-consorcios/${id}/historico?&page=${pageIndex}`,
    );
  }

  getHistoricoEmpresa(id: string, pageIndex: number = 0) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-empresas/${id}/historico?&page=${pageIndex}`,
    );
  }

  getConsorcios(razaoSocial: string = '') {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-consorcios?searchTerm=${razaoSocial}`,
    );
  }

  getEmpresas(razaoSocial?: string) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-empresas?razaoSocial=${razaoSocial}`,
    );
  }

  getConsorciosById(idEmpresa: any) {
    return this.http.get(
      this.baseUrl + `/v1/entidades/celulas-consorcios/${idEmpresa}`,
    );
  }

  getCelulasEmpresasById(idConsorcio: any) {
    return this.http.get(
      this.baseUrl + `/v1/entidades/celulas-empresas/${idConsorcio}`,
    );
  }

  getCelulasEmpresasConsorcios(
    searchTerm: string = '',
    pageSize: number = 10,
    pageIndex: number = 0,
  ) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-empresas-consorcios?&page=${pageIndex}&size=${pageSize}&searchTerm=${searchTerm}`,
    );
  }

  getCelulasEmpresasConsorciosAtendimento(
    searchTerm: string = '',
    pageSize: number = 10,
    pageIndex: number = 0,
  ) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/celulas-empresas-consorcios-atendimentos?&page=${pageIndex}&size=${pageSize}&searchTerm=${searchTerm}`,
    );
  }

  getEntitiesByResponsavel(
    pageIndex: number,
    sortDirection: string,
    sortProperty: string,
    cpf: string,
    nomeCompleto: string,
    funcao: string,
    email: string,
    cpnj: string,
  ) {
    return this.http.get(
      this.baseUrl +
        `v1/representantive-legal?cpf=${cpf}&nomeCompleto=${nomeCompleto}&funcao=${funcao}&email=${email}`,
    );
  }

  activate(companyId: number) {
    return this.http.patch(
      this.baseUrl + `/v1/companie/${companyId}/active`,
      {},
    );
  }

  inactivate(companyId: number) {
    return this.http.patch(
      this.baseUrl + `/v1/companie/${companyId}/inactive`,
      {},
    );
  }

  vinculateEntiteConcession(companyId: string, data: any) {
    const object = {
      unidadeAdministrrativa: data[0].concessoes[0].id,
    };

    // Construir a URL
    const url = `${this.baseUrl}/v1/companie/${companyId}/concession`;

    // Fazer a requisição HTTP
    return this.http.post(url, object);
  }

  getEntitieConcessionVinculated(
    companyId: string,
    sortDirection?: string,
    sortProperty?: string,
    cnpj?: string,
    razaoSocial?: string,
    cnpjOrRazaoSocial?: string,
  ) {
    // Construir a URL base
    let url = `${this.baseUrl}/v1/companie/${companyId}/concessionare`;

    // Inicializar um array de parâmetros
    const params: string[] = [];

    // Adicionar parâmetros opcionais ao array
    if (sortDirection) {
      params.push(`sortDirection=${sortDirection}`);
    }
    if (sortProperty) {
      params.push(`sortProperty=${sortProperty}`);
    }
    if (cnpj) {
      params.push(`cnpj=${cnpj}`);
    }
    if (razaoSocial) {
      params.push(`razaoSocial=${razaoSocial}`);
    }
    if (cnpjOrRazaoSocial) {
      params.push(`cnpjOrRazaoSocial=${cnpjOrRazaoSocial}`);
    }

    // Se houver parâmetros, adicioná-los à URL
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    // Fazer a requisição HTTP
    return this.http.get(url);
  }

  getConcessionDisponivel(companyId: string) {
    const apiUrl = `${this.baseUrl}/v1/companie?tipoEntidade=Concessionaria&status=true`;
    return this.http.get(apiUrl);
  }

  removeVinculoConcession(companyId: any, data: any) {
    // Construir a URL
    const url = `${this.baseUrl}/v1/companie/${companyId}/concession`;

    // Fazer a requisição HTTP
    return this.http.delete(url, { body: data });
  }

  getEntityWithLinkedData(EntitieId: string) {
    return this.http.get(this.baseUrl + `/v1/companies/${EntitieId}`);
  }

  linkUsersToEntity(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(this.baseUrl + '/v1/companies/update/users', data, {
      headers,
    });
  }

  linkConsorciosToEntity(data: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.patch(
      this.baseUrl + '/v1/companies/update/consortium',
      data,
      {
        headers,
      },
    );
  }

  getEntitiesByCnpjRazaoSocial(cnpjAndRazaoSocial: string) {
    return this.http.get(
      this.baseUrl +
        `/v1/companies?cnpjAndRazaoSocial=${cnpjAndRazaoSocial}
      `,
    );
  }

  getRitEmpresasConsorcios(searchTerm: string = '', pageSize: number = 10) {
    return this.http.get(
      this.baseUrl +
        `/v1/entidades/rit-consorcios?size=${pageSize}&searchTerm=${searchTerm}`,
    );
  }
}
